var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[ _vm.classes ],on:{"click":_vm.clicked}},[(_vm.icon != '')?_c('i',{class:_vm.icon}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }